import * as React from "react";
import { FC } from "react";
import { AddressId } from "firefly-shared-ts-domain";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  useTheme,
} from "@mui/material";
import { EnvironmentAwareBuilding } from "./EnvironmentAwareBuilding";
import { useTranslation } from "react-i18next";

export interface BuildingSelectProps {
  buildings: Array<EnvironmentAwareBuilding>;
  selected: AddressId | undefined;
  onChange: (value: AddressId) => void;
}
export const BuildingSelect: FC<BuildingSelectProps> = (props) => {
  const { t } = useTranslation("my-chimney-ts-translations");
  const theme = useTheme();
  const handleChange = (event: SelectChangeEvent, child: React.ReactNode) => {
    props.onChange(event.target.value);
  };
  return (
    <FormControl size={"small"}>
      <InputLabel>{t("Building")}</InputLabel>
      <Select
        label={t("Building")}
        value={props.selected ?? ""}
        onChange={handleChange}
        MenuProps={{
          PaperProps: {
            sx: {
              background: theme.palette.secondary.light,
            },
          },
        }}
      >
        {props.buildings.map((it) => {
          return (
            <MenuItem
              key={it.id}
              selected={it.id === props.selected}
              value={it.id}
            >
              {it.name} ({it.environment.name})
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
